import axios from 'lib/axios'
import {
  CreateExclusionRulePayload,
  ExcludedRecordsPayload,
  ExcludedRecordsResponse,
  ExclusionFieldsResponse,
  ExclusionRule,
  ExclusionRuleScopeType,
  ExclusionRulesListResponse,
  UpdateExclusionRulePayload
} from 'models'

const basePath = '/api/v4/rules'

export const ExclusionRulesServiceV4 = {
  getExclusionFields: async (cpiId: string) => {
    return axios.get<ExclusionFieldsResponse>(`${basePath}/${cpiId}/exclusion_fields`)
  },
  getFieldValues: async (cpiId: string, fieldName: string) => {
    return axios.post<string[]>(`/api/v4/metrics/${cpiId}/lookup`, { lookup: { column_name: fieldName } })
  },
  getPreviewName: async (scopeType: ExclusionRuleScopeType, scopeId: string) => {
    return axios.get<string>(`${basePath}/preview-name`, {
      params: { scope_type: scopeType, scope_id: scopeId }
    })
  },
  createRule: async (payload: CreateExclusionRulePayload) => {
    return axios.post<ExclusionRule>(basePath, payload)
  },
  getRule: async (ruleId: string) => {
    return axios.get<ExclusionRule>(`${basePath}/${ruleId}`)
  },
  updateRule: async (ruleId: string, payload: UpdateExclusionRulePayload) => {
    return axios.put<ExclusionRule>(`${basePath}/${ruleId}`, payload)
  },
  listRules: async (cpiId: string) => {
    return axios.post<ExclusionRulesListResponse>(`${basePath}/${cpiId}/rules_list/filter`)
  },
  deleteRules: async (ruleIds: string[]) => {
    return axios.delete(basePath, { data: ruleIds })
  },
  listExcludedRecords: async <T = Record<string, unknown>>(ruleUuid: string, payload: ExcludedRecordsPayload) => {
    return axios.post<ExcludedRecordsResponse<T>>(`${basePath}/${ruleUuid}/excluded-records/filter`, payload)
  }
}
